import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyProductVariantKey,
  ShopifySellingPlanGroupKey,
  ShopifySellingPlanGroupProductVariantIdKey,
  ShopifySellingPlanGroupProductVariantKey,
  ShopifySellingPlanGroupProductVariantToProductVariantKey,
  ShopifySellingPlanGroupProductVariantToSellingPlanGroupKey,
  ShopifySellingPlanGroupProductVariantToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifySellingPlanGroupProductVariantKey,
  "2022-01": {
    name: "Shopify Selling Plan Group Product Variant",
    fields: [
      {
        name: "ID",
        key: ShopifySellingPlanGroupProductVariantIdKey,
        fieldType: FieldType.ID,
      },
      {
        name: "Selling Plan Group",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductVariantToSellingPlanGroupKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanGroupKey,
        },
      },
      {
        name: "Product Variant",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductVariantToProductVariantKey,
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifySellingPlanGroupProductVariantToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifySellingPlanGroup
    syncConfig: { type: "inherit" } as const,
  },
};

export const ShopifySellingPlanGroupProductVariant = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
